import clsx from 'clsx';
import ContentTaskbar from '../../content/ContentTaskbar';
import LeadsTaskbar from '../../leads/LeadsTaskbar';
import CallCentreTaskbar from '../../call-centre/CallCentreTaskbar';
import HelpAssistant from '../help/HelpAssistant';

/** Content Studio + Leads Tracker + Help icon actions in the top navbar. */
export default function NavbarQuickActions({ className }) {
  return (
    <div
      className={clsx('flex items-center gap-3 shrink-0', className)}
      aria-label="Quick actions"
    >
      <ContentTaskbar />
      <LeadsTaskbar />
      <CallCentreTaskbar />
      <HelpAssistant />
    </div>
  );
}